import {React, useRef} from "react";
import {useEffect, useState} from "react";
import {salesOrderAPI} from "../../api/api";
import {Button, CardGroup} from "react-bootstrap";
import {SalesOrderNew} from "../SalesOrderNew/SalesOrderNew";
import {SalesOrderHeaderNew} from "../SalesOrderNew/SalesOrderHeaderNew"
import { Accordion, AccordionTab } from 'primereact/accordion';
import style from './SalesOrderHistory.module.css'
import "./SalesOrderHistory.css"
import {Toast} from "primereact/toast";
import styles from "../Catalog/Catalog.module.css";
import {ProgressSpinner} from "primereact/progressspinner";
import { SpinnerUA } from "../../common/Spinners/SpinerUA/SpinnerUA";

export const SalesOrderHistory = ({}) => {

    const [isLoading, setIsLoading] = useState(true);
    
    const [cancelOrderModel, setCancelOrderModel] = useState({});

    const [salesOrderList, setSalesOrderList] = useState([]);
    const [totalDeltaAmount, setTotalDeltaAmount] = useState(0.00)
    const [totalOverdueDeltaAmount, setTotalOverdueDeltaAmount] = useState(0.00)
    const [isSuccess, setIsSuccess] = useState(false);
    const [isDebtOverdue, setIsDebtOverdue] = useState(false);
    const toast = useRef(null);

    const [crmMessage, setCrmMessage] = useState('');
    const [show, setShow] = useState(false);

    useEffect(() => {
        getClientSalesOrder().then();
    }, [])

    useEffect(() =>{
        if(salesOrderList.length > 0){
            calcTotalDeltaAmount();
        }
    }, [salesOrderList])

    const handleClose = () => {
        //зануляем сообщение
        setCrmMessage('');
    }

    const calcTotalDeltaAmount = () =>{
        let totalDeltaAmount = 0.00;
        let totalOverdueDeltaAmount = 0.00
        salesOrderList.forEach((item) =>{
            totalDeltaAmount += parseFloat((item.TotalDeltaAmount).toFixed(2));
            if(item.IsDebtOverdue){
                totalOverdueDeltaAmount += parseFloat((item.TotalDeltaAmount).toFixed(2));
            }
        })

        setTotalDeltaAmount(totalDeltaAmount);
        setTotalOverdueDeltaAmount(totalOverdueDeltaAmount)
    }

    const setLoadingFalse = () => {
        setTimeout(() => {
            setIsLoading(false);
        }, 300)
    }

    const getClientSalesOrder = async () => {
        setIsLoading(true);
        const {data} = await salesOrderAPI.getAll()
        try {
            const result = JSON.parse(data);

            if(result.isSucccess &&  result.data.length) {
                setIsSuccess(true);
                setSalesOrderList(result.data);
                let isDebtOverDue = result.data.some(obj => obj.IsDebtOverdue === true);
                setIsDebtOverdue(isDebtOverDue)
            }
            else if(result.isSucccess &&  result.data.length == 0){
                setIsSuccess(true);
                setSalesOrderList([]);
            }
            else if(!result.isSucccess)
            {
                setIsSuccess(false);
            }
        }
        catch (ex){
            console.log(ex);
        }
        setLoadingFalse();
    };

    const getTestClientSalesOrder = async () => {
        let first = initialState[0];


        setSalesOrderList([first]);
        setIsLoading(false);
        setIsSuccess(true);
    }

    //if (salesOrderList.length === 0) {
    if (salesOrderList.length === 0 && !isLoading && isSuccess) {
        return (<div className="history" >
                <div>Ми швидко не знайшли вашу історію замовлень, але ми зробимо все можливе, щоб історія обов'язково тут з'явилась.</div>
                <div>Якщо вам необхідна зараз ця інформація, зверніться будь ласка до нашого менеджера</div>
            </div>)
    }
    else if(!isSuccess && !isLoading){
        return (<div className="history">Помилка завантаження історії замовлень.</div>)
    }

    return (

        

        <div className={style.salesOrderHistoryWrapper}>
            <Toast style={{zIndex:'1000'}} ref={toast}></Toast>
            {!isLoading ? <div className={style.header}>
                <h2>Мої замовлення</h2>
                <div style={{display:'flex'}}>
                    <div style={{marginRight:'10px'}}>
                        <h5 className={style.totalDeltaAmount}>Загальна заборгованність: </h5>
                        {isDebtOverdue ? <h5 className={style.totalOverdueDeltaAmount}>Прострочена заборгованність: </h5> : null}
                    </div>
                    <div style={{display:'flex', flexDirection:'column'}}>
                        <h5  className={style.totalDeltaAmount}>{totalDeltaAmount.toLocaleString('uk-UA', { style: 'currency', currency: 'UAH' })}</h5>
                        {isDebtOverdue ?<h5 className={style.totalOverdueDeltaAmount}>{totalOverdueDeltaAmount.toLocaleString('uk-UA', { style: 'currency', currency: 'UAH' })}</h5> : null}
                    </div>
                </div>
            </div>: null}

            
                <Accordion multiple  >
                    {
                        salesOrderList.map((salesOrder, index) =>
                            <AccordionTab key={salesOrder.CrmId + index} style={{padding:'5px'}}
                                header={
                                    <SalesOrderHeaderNew
                                    key={salesOrder.CrmId}
                                    id={salesOrder.Id}
                                    crmId={salesOrder.CrmId}
                                    data={salesOrder.CreatedOn}
                                    number={salesOrder.CrmNumber}
                                    productList={salesOrder.SalesOrderDetail}
                                    totalAmount ={salesOrder.TotalAmount}
                                    totalDeltaAmount ={salesOrder.TotalDeltaAmount}
                                    shipmentState = {salesOrder.ShipmentStateDescription}
                                    salesOrderState = {salesOrder.SalesOrderStateDescription}
                                    salesOrderStateCode = {salesOrder.SalesOrderState}
                                    actualShipmentDate = {salesOrder.ActualShipment}
                                    requestDeliveryBy={salesOrder.RequestDeliveryBy}
                                    shippingMethodCodeDescription ={salesOrder.ShippingMethodCodeDescription}
                                    accountingTypeCodeDescription={salesOrder.AccountingTypeCodeDescription}
                                    paymentTypeCodeDescription={salesOrder.PaymentTypeCodeDescription}
                                    addressDeliveryIdName={salesOrder.AddressDeliveryIdName}
                                    contactShippingIdName={salesOrder.ContactShippingIdName}
                                    contactPaymentIdName={salesOrder.ContactPaymentIdName}
                                    isDebtOverdue={salesOrder.IsDebtOverdue}
                                    loadSalesOrder={getClientSalesOrder}
                                    toast={toast}
                                />
                                }
                            >
                                <SalesOrderNew
                                    key={salesOrder.CrmId}
                                    id={salesOrder.Id}
                                    crmId={salesOrder.CrmId}
                                    data={salesOrder.CreatedOn}
                                    number={salesOrder.CrmNumber}
                                    productList={salesOrder.SalesOrderDetail}
                                    totalAmount ={salesOrder.TotalAmount}
                                    totalDeltaAmount ={salesOrder.TotalDeltaAmount}
                                    shipmentState = {salesOrder.ShipmentStateDescription}
                                    salesOrderState = {salesOrder.SalesOrderStateDescription}
                                    salesOrderStateCode = {salesOrder.SalesOrderState}
                                    actualShipmentDate = {salesOrder.ActualShipment}
                                    requestDeliveryBy={salesOrder.RequestDeliveryBy}
                                    shippingMethodCodeDescription ={salesOrder.ShippingMethodCodeDescription}
                                    accountingTypeCodeDescription={salesOrder.AccountingTypeCodeDescription}
                                    paymentTypeCodeDescription={salesOrder.PaymentTypeCodeDescription}
                                    addressDeliveryIdName={salesOrder.AddressDeliveryIdName}
                                    contactShippingIdName={salesOrder.ContactShippingIdName}
                                    contactPaymentIdName={salesOrder.ContactPaymentIdName}
                                    isDebtOverdue={salesOrder.IsDebtOverdue}
                                    loadSalesOrder={getClientSalesOrder}
                                    toast={toast}
                                />
                            </AccordionTab>
                        )
                    }
                </Accordion>

            {isLoading ? <div className={styles.spinner}>
                <SpinnerUA />
            </div> : null}

        </div>
    )
}